<template>
    <VSwitch
        v-model="val"
        :class="{ 'v-switch-on': val }"
        :label="label"
        :density="density"
        :hint="hint"
        :messages="messages"
        :disabled="disabled"
        :readonly="readonly"
        :inset="inset"
        :loading="loading"
        :errorMessages="errorMessages" />
</template>

<script lang="ts">
    import { defineComponent, watch, ref, PropType } from 'vue';
    import { VSwitch } from 'vuetify/components';
    import { Density } from './Switch.interfaces';

    export default defineComponent({
        name: 'Switch',
        components: { VSwitch },
        emits: ['update:modelValue'],
        props: {
            modelValue: Boolean,
            label: String,
            hint: String,
            loading: { type: Boolean as PropType<boolean>, default: false },
            disabled: { type: Boolean as PropType<boolean>, default: false },
            readonly: { type: Boolean as PropType<boolean>, default: false },
            inset: { type: Boolean as PropType<boolean>, default: true },
            messages: { type: Array as PropType<string[]> },
            errorMessages: {
                type: [Array, String] as PropType<string[] | string>,
            },
            density: { type: String as PropType<Density>, default: 'default' },
        },
        setup(props, { emit }) {
            const val = ref<boolean | undefined>(props.modelValue);

            watch(
                () => props.modelValue,
                (newValue, prevValue) => {
                    if (newValue !== prevValue) {
                        val.value = newValue;
                    }
                }
            );

            watch(
                () => val.value,
                (newValue, prevValue) => {
                    if (newValue !== prevValue) {
                        emit('update:modelValue', newValue);
                    }
                }
            );

            return {
                val,
            };
        },
    });
</script>
